import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import CreateQuizPage from "../pages/staff/quiz-page/create-quiz-page/create-quiz.component";
import ViewQuizzesPage from "../pages/staff/quiz-page/view-quiz-page/view-quiz-page.component";
import DeleteQuizPage from "../pages/staff/quiz-page/delete-quiz-page/delete-quiz-page.component";
import ManageQuestionPage from "../pages/staff/quiz-page/manage-question-page/manage-question-page.component";
import QuizPage from "../pages/staff/quiz-page/quiz-page.component";
import UpdateQuizPage from "../pages/staff/quiz-page/update-quiz-page/update-quiz-page.component";
import DeleteQuestionPage from "../pages/staff/quiz-page/delete-question-page/delete-question-page.component";
import UpdateQuestionPage from "../pages/staff/quiz-page/update-question-page/update-question-page.component";
import FeedbackPage from "../pages/feedback-page/feedback-page.component";
import LogOut from "../pages/logout/logout.component";
import HomePage from "../pages/home-page/home-page.component";
import CoursePage from "../pages/staff/course-page/course-page.component";

export default function StaffRoutes() {
    return (
        <>
            <Switch>
                <Route exact path="/home" component={HomePage} />
                <Route exact path="/quiz" component={QuizPage} />
                <Route exact path="/quiz/create" component={CreateQuizPage} />
                <Route exact path="/quiz/view" component={ViewQuizzesPage} />
                <Route exact path="/course" component={CoursePage} />
                <Route
                    exact
                    path="/quiz/delete/:id"
                    component={DeleteQuizPage}
                />
                <Route exact path="/quiz/:id" component={UpdateQuizPage} />
                <Route
                    exact
                    path="/quiz/:id/question"
                    component={ManageQuestionPage}
                />
                <Route
                    exact
                    path="/quiz/:id/question/:number/"
                    component={UpdateQuestionPage}
                />
                <Route
                    exact
                    path="/quiz/:id/question/delete/:number/"
                    component={DeleteQuestionPage}
                />
                <Route exact path="/feedback" component={FeedbackPage} />
                <Route exact path="/log-out" component={LogOut} />
                <Redirect exact to="/home" />
            </Switch>
        </>
    );
}
